import { render, staticRenderFns } from "./BlockModal.vue?vue&type=template&id=8f18e82c&scoped=true"
import script from "./BlockModal.vue?vue&type=script&lang=js"
export * from "./BlockModal.vue?vue&type=script&lang=js"
import style0 from "./BlockModal.vue?vue&type=style&index=0&id=8f18e82c&prod&lang=scss&scoped=true"
import style1 from "./BlockModal.vue?vue&type=style&index=1&id=8f18e82c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f18e82c",
  null
  
)

export default component.exports